import { render, staticRenderFns } from "./OrderInvoiceForm.vue?vue&type=template&id=15d9107d&"
import script from "./OrderInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./OrderInvoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports